/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
// ==============================================
// ==================Import======================
// ==============================================

// ==================Dependancies React=================
import {
  forwardRef,
  useRef,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';

// ==================Actions=================
import {
  saveInvertedNetwork, saveNetworkGridFilter,
} from '../../../actions/site';

export default forwardRef((props, ref) => {
  // ==================HOOKS=================
  const dispatch = useDispatch();
  const network = useSelector((state) => state.site.filter.network);
  const invertedNetwork = useSelector((state) => state.site.filter.invertedNetwork);
  const gridRef = useRef();

  // Remove precedent filter and save new value selected by user
  const onInputBoxChanged = (input) => {
    if (input.target.value === '') {
      dispatch(saveNetworkGridFilter(''));
      // Remove the filter
      props.parentFilterInstance((instance) => {
        instance.onFloatingFilterChanged('includedNetworks', null);
      });
      return;
    }
    dispatch(saveNetworkGridFilter(input.target.value));
    props.parentFilterInstance((instance) => {
      instance.onFloatingFilterChanged('includedNetworks', input.target.value);
    });
  };

  const onInputLatBoxChanged = (input) => {
    if (input.target.value === '') {
      dispatch(saveInvertedNetwork(''));
      // Remove the filter
      props.parentFilterInstance((instance) => {
        instance.onFloatingFilterChanged('excludedNetworks', null);
      });
      return;
    }
    dispatch(saveInvertedNetwork(input.target.value));
    props.parentFilterInstance((instance) => {
      instance.onFloatingFilterChanged('excludedNetworks', input.target.value);
    });
  };

  // ==================Styles=================
  const style = {
    color: props.color,
    width: '100%',
    maxHeight: '24px',
    margin: 'auto',
    marginTop: '0.2em',
    border: '1px solid gray',
    borderRadius: '3px',
    display: 'block',
  };

  const containerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
  };

  return (
    <div
      style={containerStyle}
    >
      <input
        placeholder="ex: epn,igs,..."
        id="networkInclude"
        ref={gridRef}
        value={network}
        style={style}
        type="text"
        onInput={onInputBoxChanged}
      />
      <input
        placeholder="inverse filter"
        id="networkExclude"
        ref={gridRef}
        value={invertedNetwork}
        style={style}
        type="text"
        onInput={onInputLatBoxChanged}
      />
    </div>
  );
});
